import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "shangpin",
    redirect: "/shangpin",
  },
  {
    path: "/shangpin",
    name: "shangpin",
    meta: {
      title: "商品",
      requireAuth: false,
    },
    component: () => import("@/views/shangpin.vue"),
  },
  {
    path: "/shangjia",
    name: "shangjia",
    meta: {
      title: "商家",
      requireAuth: false,
    },
    component: () => import("@/views/shangjia.vue"),
  },
  {
    path: "/details",
    name: "details",
    meta: {
      title: "订单详情",
      requireAuth: false,
    },
    component: () => import("@/views/details.vue"),
  },
  {
    path: "/ce",
    name: "ce",
    meta: {
      title: "ce",
      requireAuth: false,
    },
    component: () => import("@/views/ce.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    meta: {
      title: "privacy",
      requireAuth: false,
    },
    component: () => import("@/views/privacy.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    meta: {
      title: "terms",
      requireAuth: false,
    },
    component: () => import("@/views/terms.vue"),
  },

];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.isscroll) {
      return { x: 0, y: 0 }; // 否则滚动到页面顶部
    }
  },
});

export default router;
